import React from 'react';

import MenuItem from '@material-ui/core/MenuItem';

function ActionsChoice({label, onClick}) {
    return (
        <MenuItem onClick={onClick}>{label}</MenuItem>
    );
}
export default ActionsChoice;